import React from 'react';
import ReactDOM from "react-dom";
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import HelpComponent from '../HelpComponent';

class BIMAttrsOption extends React.Component{
    constructor(){
        super();
        this.state = {
            layerHandel:{},
            openAttrsList:[],
            Attrs:{},
            displayColorPicker: false,
            color: {
                r: 255,
                g: 0,
                b: 0,
                a: 100,
            },
            hexColor:"#F17013",
        };
    }
    componentDidMount(){
        let layerHandel = this.props.layerHandel;
        let openAttrsList = this.props.openAttrsList;
        let isOtherEnable = this.props.isOtherEnable;
        let Attrs = this.props.Attrs;
        layerHandel.setEntityColorFunction(["Family"], function(id, attrs, color) {
            let isTrue = false;
            for(let i = 0 ; i < openAttrsList.length ; i++){
                if(attrs[0] === openAttrsList[i].Attrs){
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if(!isTrue){
                color[3] = 0;
                return isOtherEnable;
            }
        })
        this.setState({
            layerHandel:layerHandel,
            openAttrsList:openAttrsList,
            Attrs:Attrs
        });
    }
    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };
    
    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };
    
    handleChange = (color) => {
        let layerHandel = this.state.layerHandel;
        let openAttrsList = this.state.openAttrsList;
        let isOtherEnable = this.props.isOtherEnable;
        let Attrs = this.state.Attrs;
        let onChangeAttrs = this.props.onChangeAttrs;
        this.setState({
            color: color.rgb,
            hexColor:color.hex
        });
        for(let i=0;i<openAttrsList.length;i++){
            if(openAttrsList[i].Name === Attrs.Name){
                openAttrsList[i].r = Attrs.r = color.rgb.r;
                openAttrsList[i].g = Attrs.g = color.rgb.g;
                openAttrsList[i].b = Attrs.b = color.rgb.b;
                openAttrsList[i].a = Attrs.a = color.rgb.a * 255;
                break;
            }
        };
        layerHandel.setEntityColorFunction(["Family"], function(id, attrs, color) {
            let isTrue = false;
            for(let i = 0 ; i < openAttrsList.length ; i++){
                if(attrs[0] === openAttrsList[i].Attrs){
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if(!isTrue){
                color[3] = 0;
                return isOtherEnable;
            }
        });
        onChangeAttrs(openAttrsList);
        this.setState({
            openAttrsList:openAttrsList,
            Attrs:Attrs
        });
    }
    
    isAttrsEnable(){
        let layerHandel = this.state.layerHandel;
        let openAttrsList = this.state.openAttrsList;
        let isOtherEnable = this.props.isOtherEnable;
        let Attrs = this.state.Attrs;
        let onChangeAttrs = this.props.onChangeAttrs;        
        for(let i=0;i<openAttrsList.length;i++){
            if(openAttrsList[i].Name === Attrs.Name){
                openAttrsList[i].enable = Attrs.enable = !Attrs.enable;
                break;
            }
        };
        layerHandel.setEntityColorFunction(["Family"], function(id, attrs, color) {
            let isTrue = false;
            for(let i = 0 ; i < openAttrsList.length ; i++){
                if(attrs[0] === openAttrsList[i].Attrs){
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if(!isTrue){
                color[3] = 0;
                return isOtherEnable;
            }
        });
        onChangeAttrs(openAttrsList);
        this.setState({
            openAttrsList:openAttrsList,
            Attrs:Attrs
        });
    }

    deleteAttrsOption(){
        let layerHandel = this.state.layerHandel;
        let openAttrsList = this.state.openAttrsList;
        let isOtherEnable = this.props.isOtherEnable;
        let Attrs = this.state.Attrs; 
        let DeleteBIMAttrs = this.props.DeleteBIMAttrs;  
        for(let i=0;i<openAttrsList.length;i++){
            if(openAttrsList[i].Name === Attrs.Name){
                openAttrsList.splice(i,1);
                break;
            }
        };
        layerHandel.setEntityColorFunction(["Family"], function(id, attrs, color) {
            let isTrue = false;
            for(let i = 0 ; i < openAttrsList.length ; i++){
                if(attrs[0] === openAttrsList[i].Attrs){
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if(!isTrue){
                color[3] = 0;
                return isOtherEnable;
            }
        });
        DeleteBIMAttrs(openAttrsList,Attrs);
    }

    render(){
        const attrs = this.props.Attrs;
        const styles = reactCSS({
            'default': {
              color: {
                width: '100%',
                height: '14px',
                borderRadius: '2px',
                background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
              },
              swatch: {
                padding: '5px',
                width: '100%',
                background: '#fff',
                borderRadius: '10px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'fixed',
                zIndex: '2000'
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
              },
            },
          });
        return(
            <div className="ts grid">
                <div className="ts six wide column" style={{alignSelf: 'center',overflowX:"hidden"}}>
                    <h6 className="layerNameCSS">{attrs.Name}</h6>
                </div>
                <div className="ts six wide column" style={{alignSelf: 'center'}}>
                    <div style={{textAlign: 'center'}}>
                        <div style={ styles.swatch } onClick={ this.handleClick }>
                            <div style={ styles.color } />
                        </div>
                        { 
                            this.state.displayColorPicker ? 
                                <div style={ styles.popover }>
                                    <div style={ styles.cover } onClick={ this.handleClose }/>
                                        <SketchPicker color={ this.state.color } onChange={ this.handleChange } />
                                    </div> : null 
                        }
                    </div>
                </div>
                <div className="ts two wide column" style={{alignSelf: 'center'}}>
                    <button class="ts circular icon button" onClick={(e)=>this.isAttrsEnable()}>
                        {
                            this.state.Attrs.enable?
                            <i class="hide icon"></i>:<i class="unhide icon"></i>
                        }
                        
                    </button>
                </div>
                <div className="ts two wide column" style={{alignSelf: 'center'}}>
                    <button class="ts circular icon button" onClick={(e)=>this.deleteAttrsOption()}>
                        <i class="minus icon"></i>
                    </button>
                </div>
            </div>
        );
    }
}

class ModelOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            cover : "null",
            attrsList : [],
            openAttrsList : [],
            BIMAttrsChange : {},
            isOtherEnable : true,
            helpMode : "None"
        };
    }
    componentDidMount(){
        let attrsList = [];
        let BIMAttrsList = this.props.layer.BIMAttrsList;
        for(let i=0;i<BIMAttrsList.length;i++){
            attrsList.push(
                {
                    NAME:BIMAttrsList[i].NAME,
                    ATTRS:BIMAttrsList[i].ATTRS
                }
            );
        }
        this.setState({attrsList:attrsList,BIMAttrsChange:attrsList[0]});
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        let ModelLayer = this.props.layer.layerHandel;
        ModelLayer.goto();
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    coverChange(event){
        let cover = event.target.value;
        let ModelLayer = this.props.layer.layerHandel;
        if(cover === "null"){
            ModelLayer.setOverlayName();
            window.main.OView.updateScreen();
        }            
        else{
            ModelLayer.setOverlayName(cover);
            window.main.OView.updateScreen();
        }            
        this.setState({cover : cover});
    }
    BIMAttrsAddChange(event){
        let attrsList = this.state.attrsList;
        let BIMAttrsChange = {};
        for(let i=0;i<attrsList.length;i++){
            if(attrsList[i].ATTRS === event.target.value){
                BIMAttrsChange = attrsList[i];
                this.setState({BIMAttrsChange:BIMAttrsChange});
                return null;
            }
        }
    }
    AddBIMAttrs(){
        let attrsList = this.state.attrsList;
        let openAttrsList = this.state.openAttrsList;
        let BIMAttrsChange = this.state.BIMAttrsChange;
        for(let i=0;i<attrsList.length;i++){
            if(attrsList[i] === BIMAttrsChange){
                openAttrsList.push({
                    Name:attrsList[i].NAME,
                    Attrs:attrsList[i].ATTRS,
                    r:255,
                    g:0,
                    b:0,
                    a:255,
                    enable:true
                });
                attrsList.splice(i,1);
                if(attrsList[i])
                    BIMAttrsChange = attrsList[i];
                else
                    BIMAttrsChange = attrsList[0];
                this.setState({attrsList:attrsList,openAttrsList:openAttrsList,BIMAttrsChange:BIMAttrsChange});
                return null;
            }
        }
    }
    onChangeAttrs(openAttrsList){
        this.setState({openAttrsList:openAttrsList});
    }
    DeleteBIMAttrs(openAttrsList,Attrs){
        let attrsList = this.state.attrsList;
        attrsList.push(
            {
                NAME:Attrs.Name,
                ATTRS:Attrs.Attrs
            }
        );
        this.setState({openAttrsList:openAttrsList,attrsList:attrsList});
    }
    enableOtherAttr(){
        let isOtherEnable = !this.state.isOtherEnable;
        const layerHandel = this.props.layer.layerHandel;
        let openAttrsList = this.state.openAttrsList;
        layerHandel.setEntityColorFunction(["Family"], function(id, attrs, color) {
            let isTrue = false;
            for(let i = 0 ; i < openAttrsList.length ; i++){
                if(attrs[0] === openAttrsList[i].Attrs){
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if(!isTrue){
                color[3] = 0;
                return isOtherEnable;
            }
        });
        this.setState({isOtherEnable:isOtherEnable});
    }
    clearEntityColor(){
        let attrsList = [];
        let openAttrsList = [];
        let BIMAttrsList = this.props.layer.BIMAttrsList;
        const layerHandel = this.props.layer.layerHandel;
        let isOtherEnable = this.state.isOtherEnable;
        for(let i=0;i<BIMAttrsList.length;i++){
            attrsList.push(
                {
                    NAME:BIMAttrsList[i].NAME,
                    ATTRS:BIMAttrsList[i].ATTRS
                }
            );
        }
        if(!isOtherEnable)
            isOtherEnable = true;
        layerHandel.removeEntityColorFunction();
        this.setState({attrsList:attrsList,openAttrsList:openAttrsList,isOtherEnable:isOtherEnable,BIMAttrsChange:attrsList[0]});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const LayerList_2D = this.props.LayerList_2D;
        const Layer = this.props.layer;
        let isBIMModel;
        if(Layer.isBIMModel){
            isBIMModel = 
            <div className="ts very narrow container segment" >                        
                <div className="ts grid">
                    <div className="ts eight wide column" style={{alignSelf: 'center'}}>
                        <h6 className="layerNameCSS">依屬性上色：</h6>
                    </div>
                    <div className="ts eight wide column">
                        <div className="ts fluid action dropdown">
                            <select className="ts fluid basic dropdown" onChange={(e)=>this.BIMAttrsAddChange(e)}>
                                {
                                    this.state.attrsList.map(
                                        (attrs) =>
                                            <option value={attrs.ATTRS}>{attrs.NAME}</option>                                        
                                    )
                                }
                            </select>
                            <div className="ts icon button" onClick={(e)=>this.AddBIMAttrs()}>
                                <i className="plus icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.openAttrsList.map(
                        (Attrs) => 
                        <BIMAttrsOption 
                            Attrs={Attrs} 
                            layerHandel={Layer.layerHandel}  
                            openAttrsList={this.state.openAttrsList} 
                            isOtherEnable={this.state.isOtherEnable} 
                            onChangeAttrs={(openAttrsList)=>this.onChangeAttrs(openAttrsList)} 
                            DeleteBIMAttrs={(openAttrsList,Attrs)=>this.DeleteBIMAttrs(openAttrsList,Attrs)} 
                            key={Attrs.Name}
                        />
                    )
                }
                <div className="ts grid">
                    <div className="ts eight wide column" style={{alignSelf: 'center'}}>
                        {
                            this.state.isOtherEnable?
                            <button class="ts fluid warning button" onClick={(e)=>this.enableOtherAttr()}>隱藏未選中屬性之圖素</button> 
                            : 
                            <button class="ts fluid info button" onClick={(e)=>this.enableOtherAttr()}>顯示未選中屬性之圖素</button> 
                        }
                    </div>
                    <div className="ts eight wide column">
                        <button class="ts fluid negative button" onClick={(e)=>this.clearEntityColor()}>清除所有上色</button>                        
                    </div>
                </div>
            </div>
        }
        else{
            isBIMModel =
            <div className="ts very narrow container segment" >                        
                <div className="ts grid">
                    <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                        <h6 className="layerNameCSS">影像披覆：</h6>
                    </div>
                    <div className="ts six wide column">
                        <select className="ts borderless basic dropdown" onChange={(e)=>this.coverChange(e)} value={this.state.cover} style={{width:"100%"}}>
                            <option value="null">無</option>
                            {
                                LayerList_2D.map(
                                    (layer)=>
                                        <option value={layer.layerName}>{layer.layerName}</option> 
                                )
                            }
                        </select>
                    </div>
                </div>
            </div>
        }
        if(this.state.helpMode === "ModelHelp" ){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/hs29BD4zvs4" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large university icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("ModelHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large setting icon"></i>
                    </div>
                </div>
                {
                    this.state.isSettingOpen? isBIMModel : null
                }
                
            </div>
        );
    }
}


class ModelLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            ModelLayer:{}
        };   
        this.ModelLayerChecked = this.ModelLayerChecked.bind(this);      
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.ModelLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,ModelLayer:{}});
            }            
        }
    }
    ModelLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if(!isChecked){
            window.main.OView.addModelLayer({
                url: window.TERRAIN_SERVER.URL,
                identifier: layer.ID,
                urlTemplate: window.TERRAIN_SERVER.URLTemplate,
                callback: function (e,ModelLayer) {
                    if(e){
                        ModelLayer.goto();
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        layerThis.props.setOpenLayer(layer,ModelLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({isChecked:isChecked,ModelLayer:ModelLayer});
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });                  
        }
        else{
            window.main.OView.removeLayer(this.state.ModelLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked;    
            layerThis.setState({isChecked:isChecked,ModelLayer:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="ModelLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.ModelLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {ModelLayer,ModelOption};